import {
  getPerformanceDetailReport,
  PerformanceDetailReportRequestParams,
} from "@/requests/reports/performance-detail-report.request";
import { useQuery } from "@tanstack/react-query";

export const usePerformanceDetailReport = (
  params: PerformanceDetailReportRequestParams,
  enabled = true,
) => {
  return useQuery({
    queryKey: [
      "companies",
      params.companyId,
      "reports",
      "questionnaires",
      "performance-detail",
      params.applicationQuizId,
    ],
    queryFn: () => getPerformanceDetailReport(params),
    enabled: !!params.companyId && !!params.applicationQuizId && enabled,
  });
};
